import React from "react";
import styled from "styled-components";
import Colors from "../../ui/global/Colors";
import Fonts from "../../ui/global/Fonts";
import ButtonLink from "../../ui/components/ButtonLink";
import Logo from "../../ui/components/Logo";
import { useNavigate } from "react-router-dom";
import { useMediaQuery } from "@mui/material";

const FooterContainer = styled.div<{ $colorMode: 'light' | 'dark' }>`
    position: relative;
    bottom: 0;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    // height: 62px;
    border-radius: 8px;
    // background-color: ${props => props.$colorMode === 'dark' ? Colors.black : Colors.background};
    // border-top: 1px solid ${props => props.$colorMode === 'dark' ? Colors.grey9 : Colors.grey1+60};
    padding: 15px 5px;
    z-index: 100;

    @media (max-width: 768px) {
        flex-direction: column; // Stack elements vertically on mobile
        gap: 10px; // Add some space between the rows
    }
`;

const LinkGrid = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 15px;
    
    @media (max-width: 768px) {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        width: 100%;
    }
`;

const Row = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 5px;
`;

const Container = styled.div<{ $side: 'left' | 'right', $isMobile: boolean }>`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: ${({ $side }) => $side === 'left' ? 'flex-start' : 'flex-end'};
    width: 100%;
    gap: 15px;
`;

interface FooterProps {
    page?: 'game' | 'art';
    colorMode?: 'light' | 'dark';
}

const Footer: React.FC<FooterProps> = ({ page = 'game', colorMode = 'dark' }) => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery('(max-width: 768px)');

    const scrollToTop = () => {
        // console.log("Scrolling to top...");
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    const onClick = (path: string) => {
        // navigate(path);
        // console.log(`Navigating to: ${path}`);
        window.open(path, '_blank');
    };

    return (
        <FooterContainer $colorMode={colorMode}>
            {isMobile ? (
                <>
                    {/* Mobile layout */}
                    {/* <LinkGrid>
                        <ButtonLink 
                            size="tiny"
                            color="grey"
                            text="Terms"
                            onClick={() => onClick('/terms-of-service')}
                        />
                        <ButtonLink 
                            size="tiny"
                            color="grey"
                            text="Privacy"
                            onClick={() => onClick('/privacy-policy')}
                        />
                    </LinkGrid> */}
                    <LinkGrid>
                        <ButtonLink 
                            size="small"
                            // color="grey"
                            color={colorMode === 'dark' ? 'white' : 'black'}
                            text="Pricing"
                            onClick={() => onClick('/pricing')}
                        />
                        <Logo 
                            colorMode={colorMode} 
                            text="left" 
                            size={16} 
                            // onClick={scrollToTop}
                        />
                    </LinkGrid>
                </>
            ) : (
                <>
                    {/* Desktop layout */}
                    <Container $side="left" $isMobile={isMobile}>
                        <LinkGrid>
                            <ButtonLink 
                                size="small"
                                // color="grey"
                                color={colorMode === 'dark' ? 'white' : 'black'}
                                text="Pricing"
                                onClick={() => onClick('/pricing')}
                            />
                            <ButtonLink 
                                size="tiny"
                                color="grey"
                                // color={colorMode === 'dark' ? 'white' : 'black'}
                                text="Terms"
                                onClick={() => onClick('/terms-of-service')}
                            />
                            <ButtonLink 
                                size="tiny"
                                color="grey"
                                // color={colorMode === 'dark' ? 'white' : 'black'}
                                text="Privacy"
                                onClick={() => onClick('/privacy-policy')}
                            />
                        </LinkGrid>
                    </Container>

                    <Container $side="right" $isMobile={isMobile}>
                        <Logo 
                            colorMode={colorMode} 
                            text="left" 
                            size={16} 
                            // onClick={scrollToTop}
                        />
                    </Container>
                </>
            )}
        </FooterContainer>
    );
};

export default Footer;